import { useEffect, useState } from 'react'
import './GigListSorter.scss'
import { Box, Modal } from '@mui/material'
import { Gig } from '../../../../Models/Gig'

interface GigSorterProps{
  data: any,
  setData: any
}

const GigListSorter = (props: GigSorterProps) => {

  const { data, setData } = props
  const dataLen = data.length
  const [windowWidth, ] = useState(window.innerWidth)
  const [open, setOpen] = useState(false)
  const [option, setOption] = useState("")

  const style = {
    position: 'absolute' as 'absolute',
    left: '50%',
    bottom: '0',
    transform: 'translate(-50%, 0%)',
    width: '100vw',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };

  const handleOpen = () => {
    if(windowWidth > 990) return;
    setOpen(true)
  }

  const sortData = () => {
    // Rating Sort
    let newData = []
    if(option === 'rating') {
      let rate1 = 0
      let rate2 = 0
      newData = [...data].sort((a: Gig, b: Gig) => {
        rate1 = (a.rating === undefined) ? 0 : a.rating
        rate2 = (b.rating === undefined) ? 0 : b.rating
        return rate2 - rate1
      })
    }
    // Cost Low-High Sort
    else if(option === 'cost1') {
      newData = [...data].sort((a: Gig, b: Gig) => a.minPrice - b.minPrice)
    }
    // Cost High-Low Sort
    else if(option === 'cost2') {
      newData = [...data].sort((a: Gig, b: Gig) => b.minPrice - a.minPrice)
    }
    else newData = [...data]
    setData(newData)
  }
  
  const handleClose = () => {
    setOpen(false)
  }

  const handleOption = (opt: string) => {
    if(opt === option) setOption("")
    else {
      setOption(opt)
    }
    if(windowWidth > 990) return;
    handleClose()
  }

  useEffect(() => {
    sortData()
    // eslint-disable-next-line
  }, [option])
  

  const addModal = () => (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <div className="sortModalHead">Sort By</div>
        <hr />
        <div className="sortModalList">
          <div className="sortModalList_item">
            <p className='item'>Relevance</p>
            <div className='radio' onClick={() => handleOption('relevance')}><span className={option==='relevance'?'active':''}></span></div>
          </div>
          <div className="sortModalList_item">
            <p className='item'>Delivery Time</p>
            <div className='radio'onClick={() => handleOption('delivery')}><span className={option==='delivery'?'active':''}></span></div>
          </div>
          <div className="sortModalList_item">
            <p className='item'>Ratings</p>
            <div className='radio'onClick={() => handleOption('rating')}><span className={option==='rating'?'active':''}></span></div>
          </div>
          <div className="sortModalList_item">
            <p className='item'>Cost: Low to High</p>
            <div className='radio'onClick={() => handleOption('cost1')}><span className={option==='cost1'?'active':''}></span></div>
          </div>
          <div className="sortModalList_item">
            <p className='item'>Cost: High to Low</p>
            <div className='radio'onClick={() => handleOption('cost2')}><span className={option==='cost2'?'active':''}></span></div>
          </div>
        </div>
      </Box>
    </Modal>
  )

  return (
    <>
      { addModal() }
      <section className='gigSorterSection'>
        <h1 className='sorter-head'>{dataLen} Listings</h1>
        <div className="sorter-option-box">
          <ul className='sorter-options'>
            {/* @TODO: Add Relevance and Delivery Time Logic */}
            {/* <li className={option === 'relevance'?'sorter-links active':'sorter-links'} onClick={()=>handleOption('relevance')}>Relevance</li> */}
            {/* <li className={option === 'delivery'?'sorter-links active':'sorter-links'} onClick={()=>handleOption('delivery')}>Delivery Time</li> */}
            <li className={option === 'rating'?'sorter-links active':'sorter-links'} onClick={()=>handleOption('rating')}>Ratings</li>
            <li className={option === 'cost1'?'sorter-links active':'sorter-links'} onClick={()=>handleOption('cost1')}>Cost: Low to High</li>
            <li className={option === 'cost2'?'sorter-links active':'sorter-links'} onClick={()=>handleOption('cost2')}>Cost: High to Low</li>
          </ul>
          <span onClick={handleOpen}>
            <i className="fa-solid fa-arrow-up-wide-short"></i>
          </span>
        </div>
      </section>
    </>
  )
}

export default GigListSorter